"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var arrow = function (_, classNames) {
  return "<div class=\"" + classNames.arrow + "\" role=\"presentation\"></div>";
};
exports.default = arrow;